<!-- hide this label for aria -->
@if (label) {
  <label
    [attr.for]="id"
    class="lm-progress-label"
    soho-label
    lm-label
    [layoutField] = "field"
    [personalize]="personalize && !field?.label?.textStyle?.color"
    lm-text-style
    [textStyle]="field?.label?.textStyle"
    >{{labelText}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
  </label>
}

<div
  lm-field-options
  [hasContextMenu]="insertContextMenu"
  [ajaxCallbackFunction]="onBeforeContextMenuOpen"
  [contextMenuEventFunction]="contextMenuClicked"
  [buttonId]="fieldOptionsId"
  [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
  [isInAccessibilityMode]="isInAccessibilityMode"
  [displayFieldOptions]="displayFieldOptions"
  [disableFieldOptions]="disableFieldOptions"
  [fieldAutomationId]="fieldAutomationId"
  soho-tooltip
  [popover]="true"
  [title]="popoverTitle"
  [placement]="'right'"
  [trigger]="'click'"
  (contextmenu)="onContextMenu($event)"
  (focusin)="onFieldFocus($event)"
  (focusout)="onFieldBlur($event)">
  <div
    [ngClass]="fieldClassesString"
    [class.personalize-text]="personalize"
    [class.data]="true"
    [attr.id]="id"
    [attr.bindId]="bindId"
    [style.display]="'inline-block'"
    [attr.tabindex]="isInAccessibilityMode ? 0 : null"
    [(ngModel)]="modelField.value"
    soho-alert
    soho-chart
    [dataSet]="chartData$ | async"
    [type]="'targeted-achievement'"
    [attr.aria-describedby]="fieldDescriptionId"
    ngDefaultControl
  ></div>
</div>
<ng-template #mouseOverTextTemplate>
  @if (layoutObject.mouseOverText) {
    <lm-mouse-over-text [beforeShowTooltip]="displayMouseOverText"></lm-mouse-over-text>
  }
</ng-template>
<span [attr.id]="fieldDescriptionId" class="audible">{{ (isFocused$ | async) ? fieldDescription : '' }}</span>